(function () {
  var page = document.querySelector('.custom-order-page.co');
  if (!page) return;

  var reveals = Array.prototype.slice.call(page.querySelectorAll('[data-reveal]'));

  function reveal(element, observer) {
    var siblings = element.parentElement
      ? Array.prototype.slice.call(element.parentElement.children).filter(function (child) {
          return child.hasAttribute('data-reveal');
        })
      : [];
    var delay = siblings.length > 1 ? Math.max(0, siblings.indexOf(element)) * 100 : 0;

    window.setTimeout(function () {
      element.classList.add('is-visible');
    }, delay);

    if (observer) observer.unobserve(element);
  }

  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) reveal(entry.target, observer);
      });
    }, { threshold: 0.12 });

    reveals.forEach(function (element) { revealObserver.observe(element); });
  } else {
    reveals.forEach(function (element) { element.classList.add('is-visible'); });
  }
})();
